import {Component, Input} from '@angular/core';
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import {OrganizationConstantValue} from '@models/adminstration/organization/constants/organization-constant-value';
import {OrganizationConstant} from '@models/adminstration/organization/constants/organization-constant';
import {ConstantsService} from '@services/administration/organization/configuration/constants/constants.service';

@Component({
    selector: 'scitis-admin-organization-constant-values-editor',
    templateUrl: './constant-values-editor.component.html',
    styleUrls: ['./constant-values-editor.component.scss'],
    standalone: false
})
export class ConstantValuesEditorComponent {

  @Input()
  constant: OrganizationConstant = new OrganizationConstant();

  @Input()
  parentFormGroup: UntypedFormGroup = new UntypedFormGroup({});

  constructor(private fb: UntypedFormBuilder,
              private constantsService: ConstantsService) {
  }

  onAddNewInterval() {
    if (this.constant.tenantConstant.constantValues === null || this.constant.tenantConstant.constantValues === undefined) {
      this.constant.tenantConstant.constantValues = new Array<OrganizationConstantValue>();
    }
    this.constant.tenantConstant.constantValues.push(new OrganizationConstantValue());
    this.addValueItemForm(this.parentFormGroup, new OrganizationConstantValue());
  }

  onRemoveInterval(index: number) {
    this.constant.tenantConstant.constantValues.splice(index, 1);
    this.removeValueItemForm(this.parentFormGroup, index);
  }

  private addValueItemForm(form: UntypedFormGroup, value: OrganizationConstantValue) {
    const valuesArray = form.controls.editValuesFormArray as UntypedFormArray;
    const arrayLength = valuesArray.length;
    valuesArray.insert(arrayLength, this.generateConstantValueItemFormGroup(value));
  }

  removeValueItemForm(form: UntypedFormGroup, i: number) {
    const valuesArray = form.controls.editValuesFormArray as UntypedFormArray;
    valuesArray.removeAt(i);
  }

  private generateConstantValueItemFormGroup(constantValue: OrganizationConstantValue): UntypedFormGroup {
    return this.fb.group({
      value: new UntypedFormControl(constantValue.value, [Validators.required]),
      startTimestamp: new UntypedFormControl(constantValue.startTimestamp, [Validators.required]),
      endTimestamp: new UntypedFormControl(constantValue.endTimestamp, [Validators.required])
    });
  }

  onValueDateChanged() {
    this.constantsService.verifyOverlappingIntervals(this.parentFormGroup);
  }
}
